import { render, staticRenderFns } from "./DevInfoView.vue?vue&type=template&id=636f2efe&"
import script from "./DevInfoView.vue?vue&type=script&lang=ts&"
export * from "./DevInfoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports